export function openExternalApp(url) {
  const authDict = JSON.parse(localStorage.getItem("auth_dict"));
  const isMobileApp = authDict?.is_mobile_app;
  if (isMobileApp && window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler(
      'EVGR_CHANNEL',
      'openExternalApp',
      { url }
    );
  } else {
    window.open(url, '_blank', 'noopener, noreferrer')
  }
}

